import { AbstractControl, ValidationErrors } from '@angular/forms';

/**
 * Número de cuenta de SuperPay: prefijo fijo `SM` + 12 dígitos (14 caracteres).
 * El formato no varía, así que se comprueba entero aquí y no se molesta al
 * backend con un dedazo.
 */
export const ACCOUNT_NUMBER_PREFIX = 'SM';
export const ACCOUNT_NUMBER_DIGITS = 12;
export const ACCOUNT_NUMBER_LENGTH = ACCOUNT_NUMBER_PREFIX.length + ACCOUNT_NUMBER_DIGITS;
export const ACCOUNT_NUMBER_REGEX = /^SM\d{12}$/;

export const ACCOUNT_NUMBER_MESSAGE =
  'El número de cuenta debe empezar por SM seguido de 12 números (14 caracteres)';

/**
 * Limpia el número de cuenta tal cual lo teclea o pega el usuario: espacios
 * (los que quedan al copiar de un chat o un PDF), guiones y minúsculas.
 */
export function normalizeAccountNumber(value: unknown): string {
  return typeof value === 'string' ? value.replace(/[\s-]/g, '').toUpperCase() : '';
}

/** Valida el formato de la cuenta sobre el valor ya normalizado. */
export function accountNumberValidator(control: AbstractControl): ValidationErrors | null {
  if (!control.value) return null;

  return ACCOUNT_NUMBER_REGEX.test(normalizeAccountNumber(control.value))
    ? null
    : { accountNumberFormat: true };
}

/**
 * Deja el campo siempre normalizado mientras se escribe o se pega, para que sea
 * imposible enviar la cuenta con espacios, guiones o minúsculas. Devuelve la
 * suscripción por si el componente necesita cancelarla.
 */
export function keepAccountNumberNormalized(control: AbstractControl) {
  return control.valueChanges.subscribe((value) => {
    const normalized = normalizeAccountNumber(value);
    if (typeof value === 'string' && value !== normalized) {
      control.setValue(normalized, { emitEvent: false });
    }
  });
}
